// Relative to the axios base URL, which already appends /api.
export const DRIVER_SALARY_PAYOUT_ENDPOINTS = {
	/** Drivers the caller sees on /drivers whose salary balance is above zero. */
	payableBalances: "DriverSalaryPayout/payable-balances",
	/** Pays each listed driver their full balance as of now. */
	pay: "DriverSalaryPayout/pay",
} as const;
